import { render, staticRenderFns } from "./BulkUpdateAttributes.vue?vue&type=template&id=16791e16&scoped=true"
import script from "./BulkUpdateAttributes.vue?vue&type=script&lang=js"
export * from "./BulkUpdateAttributes.vue?vue&type=script&lang=js"
import style0 from "./BulkUpdateAttributes.vue?vue&type=style&index=0&id=16791e16&prod&lang=css"
import style1 from "./BulkUpdateAttributes.vue?vue&type=style&index=1&id=16791e16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16791e16",
  null
  
)

export default component.exports